import { render, staticRenderFns } from "./SpacesFlow.vue?vue&type=template&id=46f5e6ce&scoped=true&"
import script from "./SpacesFlow.vue?vue&type=script&lang=js&"
export * from "./SpacesFlow.vue?vue&type=script&lang=js&"
import style0 from "./SpacesFlow.vue?vue&type=style&index=0&id=46f5e6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f5e6ce",
  null
  
)

export default component.exports